import C from "../melly_content.json";

export const AREAS = C.AREAS;
export const LESSONS = C.LESSONS;
export const QUESTIONS = C.QUESTIONS;
export const CASES = C.CASES;
export const SPOTS = C.SPOTS;
export const ORDER_ITEMS = C.ORDER_ITEMS;
export const MATCH_ITEMS = C.MATCH_ITEMS;
export const SCENARIOS = C.SCENARIOS;
export const EXAMS = C.EXAMS;
export const FLASHCARDS = C.FLASHCARDS;
export const ALL_QUESTIONS = C.ALL_QUESTIONS;
export const CONTENT_STATS = C.CONTENT_STATS;

export const t = (loc, lang) => (loc ? loc[lang] : "");
export const areaById = (id) => AREAS.find((a) => a.id === id);
export const lessonById = (id) => LESSONS.find((l) => l.id === id);
export const lessonsByArea = (id) => LESSONS.filter((l) => l.area === id);
export const examById = (id) => EXAMS.find((e) => e.id === id);
export const scenarioById = (id) => SCENARIOS.find((s) => s.id === id);

const IDX = Object.fromEntries(ALL_QUESTIONS.map((q) => [q.id, q]));
export const questionById = (id) => IDX[id];
export const questionsByArea = (id) => ALL_QUESTIONS.filter((q) => q.area === id);

export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export function pickQuestions(count, opts) {
  let pool = ALL_QUESTIONS;
  if (opts?.area) pool = pool.filter((q) => q.area === opts.area);
  if (opts?.priorityIds && opts.priorityIds.length) {
    const prio = new Set(opts.priorityIds);
    const priority = shuffle(pool.filter((q) => prio.has(q.id)));
    const rest = shuffle(pool.filter((q) => !prio.has(q.id)));
    return [...priority, ...rest].slice(0, count);
  }
  return shuffle(pool).slice(0, count);
}

export const DIMS = ["communication", "people", "decision", "conflict", "risk"];
export const dimLabel = {
  communication: { de: "Kommunikation", en: "Communication" },
  people: { de: "Mitarbeiterführung", en: "People Leadership" },
  decision: { de: "Entscheidungsqualität", en: "Decision Quality" },
  conflict: { de: "Konfliktumgang", en: "Conflict Handling" },
  risk: { de: "Risikobewusstsein", en: "Risk Awareness" },
};
